import ClockImage from 'asset/image-clock.svg'
import { IconButton } from 'component/Button'
import { RoundButton } from 'component/Button/RoundButton'
import { Modal } from 'component/Modal'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Powered } from 'page/catalog/Powered/Powered'
import { demo } from 'page/catalog/store/CatalogStore'
import css from './TimeoutModal.module.scss'

export const TimeoutModal = observer(() => {
  const session = demo.it.welcome!.timeout
  const { timer } = session
  const min = Math.trunc(timer / 60).toFixed().padStart(2, '0')
  const sec = (timer % 60).toFixed().padStart(2, '0')

  const onClose = useLatestCallback(async () => {
    session.cancel()
  })

  const onLogout = useLatestCallback(async () => {
    session.stop()
  })

  return (
    <Modal open={true} rootClassName={css.root} className={css.modal} width={640} onCancel={onClose}
      closeButton={false}>
      <Space pad={32} right>
        <IconButton link action={onClose}>
          <Icon size={32} name="close" secondary />
        </IconButton>
      </Space>
      <Vertical pad={[0, 32]} center>
        <Space className={css.clock}>
          <ClockImage />
        </Space>
        <Gap height={24} />
        <Typo size={24}>
          {i18n('doc.DocumentWillCloseIn')}
        </Typo>
        <Gap height={12} />
        <Typo size={80} bold>
          {min}:{sec}
        </Typo>
        <Gap height={40} />
        <Vertical gap={12} wide>
          <RoundButton height={64} primary onClick={onClose}>
            <Typo size={20} medium>
              {i18n('doc.Continue')}
            </Typo>
          </RoundButton>
          <RoundButton height={64} danger onClick={onLogout}>
            <Typo size={20} medium>
              {i18n('doc.Close')}
            </Typo>
          </RoundButton>
        </Vertical>
      </Vertical>
      <Space height={64} center>
        <Powered />
      </Space>
    </Modal>
  )
})
